const styObj = {
  default: {
    // Popup button - ok
    '--agent-profile-btn-ok-bg': '#8b3fff',
    '--agent-profile-btn-ok-color': '#ffffff',
    // Popup button - cancel / border
    '--agent-profile-btn-cancel-color': '#a338fc',
    '--agent-profile-btn-cancel-border': '#a338fc'
  },
  kiko: {
    // Popup button - ok
    '--agent-profile-btn-ok-bg': '#ffe242',
    '--agent-profile-btn-ok-color': '#000000',
    // Popup button - cancel / border
    '--agent-profile-btn-cancel-color': '#ff8a33',
    '--agent-profile-btn-cancel-border': '#ff8a33'
  }
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        } else {
          return styObj['default']
        }
      }
      return {}
    }
  }
}
